import { useAppDispatch } from "app/hooks";
import { setOpenPanel } from "features/settings/details-slice";
import Button from "shared/components/Button";
import { ReactComponent as MenuSVG } from "assets/icons/menu.svg";

interface PageTopMenuProps {}
const PageTopMenu: React.FC<PageTopMenuProps> = () => {
  const dispatch = useAppDispatch();

  return (
    <Button
      colour="ThemeLight"
      additionalClassNames="PageTopMenuButton PrimaryButton"
      onClick={() => {
        dispatch(setOpenPanel("farmDetails"));
      }}
      children={<MenuSVG height={30} width={30} className="SVGFillTheme" />}
    />
  );
};

export default PageTopMenu;
